
import { Component, Vue } from "vue-property-decorator";
import _ from "lodash";
import Configuration from "front-component/Configuration";
import $http from "axios";
import { MessageType } from "element-ui/types/message";

@Component
export default class CommonAuthMixin extends Vue {
    protected enterpriseLogo: string = "";
    public enterpriseName: string | null = null;
    protected enterpriseCheckQueryOver: boolean = false;

    private mounted() {
        this.isSsoEnabled();
    }

    protected handleMessage(type: MessageType, args: string, showClose: boolean = false, duration: number = 0) {
        this.$message({
            showClose: showClose || false,
            duration: 0 || duration,
            message: _.invoke(this.$options.filters, "trans", args),
            type
        });
    }
    protected getSubDomain(): string|null {
        const url = window.location.host;
        const subDomain = url.split(".").shift();

        if (subDomain === "cockpit" || !subDomain) {
            return null;
        }

        return subDomain;
    }

    protected isSsoEnabled() {
        const subDomain = this.getSubDomain();
        if (subDomain === null) {
            this.enterpriseCheckQueryOver = true;
            return false;
        }

        $http.request({
            url: `${Configuration.get("authUri")}/ssos/${subDomain}/exists`,
            method: "GET"
        }).then((response) => {
            if (response.data.ssoExists === true) {
                this.setAssets(subDomain);
            }
        }).catch((e) => {
            this.handleMessage("error", "failedAuthentication");
        });
    }
    public setAssets(subDomain: string): void {
        $http.request({
            url: Configuration.get("apiUri") + `/client-assets/${subDomain}`,
            method: "GET",
            headers: {
                "X-Requested-With": "XMLHttpRequest",
            }
        }).then((response) => {
            this.enterpriseLogo = response.data.logo;
            this.enterpriseName = response.data.name;
        }).catch((e) => {
            this.handleMessage("error", "failedAuthentication", false);
        }).finally(() => {
            this.enterpriseCheckQueryOver = true;
        });
    }
}
